import { Component } from '@angular/core';
import { Icon } from '../icon/icon.component';

@Component({
  selector: 'app-hint',
  template: `
    <div class="inline-block">
      <div class="flex items-center gap-2 bg-primary-100 rounded-md py-1 px-2 ">
        <div class="w-5 flex items-center">
          <app-icon
            name="solar:info-circle-bold-duotone"
            size="sm"
            class="text-primary w-5"
          />
        </div>
        <p class="text-sm text-gray-700 font-medium whitespace-pre-line">
          <ng-content />
        </p>
      </div>
    </div>
  `,
  imports: [Icon],
})
export class Hint {}
